export default class PersonSale {
    PersonId: number = 0;
    TNodId: number = 0;
    FirstName: string = '';
    LastName: string = '';
    SecondName: string = '';
    Phone: string = '';
}